import { Link } from "react-router-dom";
import "./about-us.css";
import ThumbUpRoundedIcon from "@mui/icons-material/ThumbUpRounded";
import FavoriteRoundedIcon from "@mui/icons-material/FavoriteRounded";
import AccessTimeFilledRoundedIcon from "@mui/icons-material/AccessTimeFilledRounded";
import aboutImg from "../../assets/img/home/asset 3.png";

const AboutUs = () => {
	return (
		<section className="about">
			<div className="container">
				<div className="img-holder">
					<img src={aboutImg} alt="about-img" />
				</div>
				<div className="text-zone">
					<h3 className="sub-title">Über uns</h3>
					<h1 className="title">
						Wir beraten <br />
						und entlasten Sie
					</h1>
					<p className="desc">
						Unerwartete Erkrankungen und zunehmendes Alter können Gründe einer
						Pflegebedürftigkeit sein. Als Angehöriger oder nahestehende Person
						ist es Ihnen ein Bedürfnis oder auch eine Selbstverständlichkeit zu
						helfen und den Pflegebedürftigen zu unterstützen.
					</p>
					<p className="desc">
						Um das gesunde Verhältnis in der herausfordernden Situation im
						Gleichgewicht zu erhalten, benötigen auch helfende Hände
						(Pflegepersonen) eine HELFENDE Hand.
					</p>
					<ul className="reacts">
						<li>
							<i>
								<ThumbUpRoundedIcon />
							</i>
							Verständnis
						</li>
						<li>
							<i>
								<FavoriteRoundedIcon />
							</i>
							Zuwendung
						</li>
						<li>
							<i>
								<AccessTimeFilledRoundedIcon />
							</i>
							Zeit
						</li>
					</ul>
					<Link to="/" className="main-btn t-3">
						Mehr Über uns
					</Link>
				</div>
			</div>
		</section>
	);
};

export default AboutUs;
